import api from '@/services/api'

export const getUserCareerObjectives = async userId => {
    try {
        const resp = await api.get(`users/${userId}/profile/career-objectives`)
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}

export const createCareerObjective = async form => {
    try {
        const resp = await api.post('career-objectives', form)
        return resp.data
    } catch (e) {
        console.error(e)
    }
}

export const updateCareerObjective = async form => {
    try {
        const resp = await api.put(`career-objectives/${form.id}`, form)
        return resp.data
    } catch (e) {
        console.error(e)
    }
}

export const deleteCareerObjective = async id => {
    try {
        return await api.delete(`career-objectives/${id}`)
    } catch (e) {
        console.error(e)
    }
}

export const getCareerObjectiveFromApi = async id => {
    try {
        const resp = await api.get(`career-objectives/${id}`)
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}
